import { motion } from "framer-motion";

export default function GrainOverlay() {
  return (
    <>
      {/* SVG film grain */}
      <div className="grain-overlay" aria-hidden="true">
        <svg viewBox="0 0 100 100" preserveAspectRatio="none">
          <filter id="grainFilter">
            <feTurbulence
              type="fractalNoise"
              baseFrequency="0.85"
              numOctaves="3"
              stitchTiles="stitch"
            />
            <feColorMatrix type="saturate" values="0" />
          </filter>
          <rect width="100" height="100" filter="url(#grainFilter)" />
        </svg>
      </div>

      {/* Ambient gradient blob */}
      <div className="ambient-blob" aria-hidden="true">
        <motion.div
          className="ambient-blob-inner"
          animate={{
            x: [0, 80, -40, 60, 0],
            y: [0, -60, 80, -30, 0],
            scale: [1, 1.2, 0.9, 1.1, 1],
          }}
          transition={{
            duration: 24,
            ease: "easeInOut",
            repeat: Infinity,
            repeatType: "mirror",
          }}
        />
      </div>
    </>
  );
}
